import React from "react";
import video from "../../assets/Ayurveda.mp4"; 

const ZeniusHero: React.FC = () => {
  return (
    <div className="font-sans text-gray-800 bg-white w-full">
      {/* Container height mobile pe auto aur aspect-ratio set kiya hai */}
      <div className="relative w-full h-auto aspect-[16/9] md:aspect-auto md:h-[500px] lg:h-[600px] overflow-hidden bg-black">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none"
        >
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        
        {/* Mobile ke liye text size aur padding thoda chota kiya hai */}
        <div className="absolute inset-0 bg-black/20 flex flex-col justify-center px-4 sm:px-10 md:px-20">
            <h1 className="text-white text-2xl sm:text-4xl md:text-6xl font-serif italic font-bold leading-tight">
                CRAFTING NATURAL <br/> 
                <span className="text-white not-italic">Wellness,</span> <br/>
                the Ayurvedic Way
            </h1>
            <div className="mt-4 bg-[#2d4a1e] text-white p-2 md:p-4 w-fit rounded-tr-2xl md:rounded-tr-3xl">
                <p className="text-xs md:text-lg font-medium italic">Nature's secret, now with you</p>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ZeniusHero;